module.exports = __webpack_public_path__ + "static/user-experience-d5cddc87bcd80707d9853f6372b1f3f7.svg";